/* eslint-disable no-unused-vars,no-new */
import {loadScript} from '../script/index'
import {resolveQuery} from '../url/index'
import env from '../env/index.js'
import {getPUserInfo, goPLogin} from './p-login'
import {getDUserInfo, goDLogin} from './d-login'
import {getH5UserInfo, goH5Login} from './h5-login'

let arrFns = []
let isReady = false
let loadScriptFlag = false

export default {
  /**
   * 初始化加载各种资源及准备工作，该函数是为了便于快速拿到用户信息及登录，如果该函数不执行，getUserInfo、login也会默认执行该函数
   * @param options
   * {
     *  appid: '777777777', //h5 passport 登录时传的appid, 默认为： '777777777
     *  role: 1, // h5 passport登录时传的role, 乘客端为1， 司机端为2. 默认值：1.
     *  env: 'production' // 通过环境判断加载线下，线上地址的passport， 默认值为"production"
     * }
   * @param callback
   */
  init (options = {}, callback) {
    this.ready(() => {
      if (typeof callback === 'function') {
        callback()
      }
    }, options)
  },
  ready (callback, options = {}) {
    let config = Object.assign({}, {
      appid: '777777777',
      role: 1,
      env: process.env.NODE_ENV
    }, options)
    if (typeof callback !== 'function') {
      return
    }
    if (isReady) {
      callback()
    } else {
      arrFns.push(callback)
      if (!loadScriptFlag) {
        loadScriptFlag = true
        this.loadJs(config)
      }
    }
  },
  loadJs (options) {
    if (env.isPassenger) {
      if (typeof D === 'undefined' || (window.D && window.D.dbridge === undefined)) {
        loadScript('//static.udache.com/agility-sdk/1.0.4/bridge.js')
          .then(() => {
            this.doFns()
          })
          .catch(e => {
            new Error(e)
          })
      } else {
        this.doFns()
      }
    } else if (env.isDriver) {
      if (typeof didi === 'undefined' || (window.didi && window.didi.dbridge === undefined)) {
        loadScript('//static.udache.com/driver/assets/js/bridge/dbridge.js')
          .then(() => {
            this.doFns()
          })
          .catch(e => {
            new Error(e)
          })
      } else {
        this.doFns()
      }
    } else {
      if (!window.login) {
        const loginSdk = options.env === 'production'
          ? '//webapp.didistatic.com/static/webapp/shield/z/login/login/0.3.21/login.min.js'
          : 'http://passport.rdtest.didichuxing.com/static/login/0.3.21/login.test.js'
        loadScript(loginSdk)
          .then(() => {
            window.login.setConfig(options)
            this.doFns()
          })
          .catch(e => {
            new Error(e)
          })
      } else {
        window.login.setConfig(options)
        this.doFns()
      }
    }
  },
  doFns () {
    arrFns.forEach((fn) => {
      fn()
    })
    isReady = true
    arrFns = []
  },
  /**
   * getUserInfo 获取用户信息
   * @param callback
   * @param options
   * {
     *  appid: '777777777', //h5 passport 登录时传的appid, 默认为： '777777777
     *  role: 1, // h5 passport登录时传的role, 乘客端为1， 司机端为2. 默认值：1.
     *  env: 'production' // 通过环境判断加载线下，线上地址的passport， 默认值为"production"
     * }
   */
  getUserInfo (callback, options) {
    let query = resolveQuery(window.location.href)
    if (query.token || query.ticket) {
      let res = {
        errno: 0,
        errmsg: 'OK',
        data: {
          token: query.token || query.ticket,
          ticket: query.ticket || query.token,
          phone: query.phone
        }
      }
      callback(res)
    } else {
      this.ready(() => {
        if (env.isPassenger) {
          getPUserInfo()
            .then((res) => {
              callback(res)
            })
            .catch((e) => {
              new Error(e)
            })
        } else if (env.isDriver) {
          getDUserInfo()
            .then((res) => {
              callback(res)
            })
            .catch((e) => {
              new Error(e)
            })
        } else {
          getH5UserInfo()
            .then((res) => {
              callback(res)
            })
            .catch((e) => {
              new Error(e)
            })
        }
      }, options)
    }
  },
  /**
   * 登录
   * @param callback
   * @param options
   * {
     *  appid: '777777777', //h5 passport 登录时传的appid, 默认为： '777777777
     *  role: 1, // h5 passport登录时传的role, 乘客端为1， 司机端为2. 默认值：1.
     *  env: 'production' // 通过环境判断加载线下，线上地址的passport， 默认值为"production"
     * }
   */
  login (callback, options) {
    this.ready(() => {
      if (env.isPassenger) {
        goPLogin()
          .then((res) => {
            callback(res)
          })
          .catch((e) => {
            new Error(e)
          })
      } else if (env.isDriver) {
        goDLogin()
          .then((res) => {
            callback(res)
          })
          .catch((e) => {
            new Error(e)
          })
      } else {
        goH5Login()
          .then((res) => {
            callback(res)
          })
          .catch((e) => {
            new Error(e)
          })
      }
    }, options)
  }
}
